<template>
    <v-form ref="form_produto">
        <v-row>
            <v-col lg="4" xl="4" class="px-2">
                <v-text-field
                    v-model="buscaProduto"
                    append-icon="mdi-magnify"
                    class="input-button input-cinza"
                    label="Pesquisar"
                    dense
                    outlined
                    hide-details
                >
                    <template>
                        <v-icon slot="append" color="white">mdi-magnify</v-icon>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="2" class="px-2">
                <v-text-field
                    label="VB"
                    v-model="vb"
                    class="input-cinza py-0"
                    outlined
                    dense
                    v-mask="'####'"
                ></v-text-field>
            </v-col>
            <v-col lg="6" xl="6" class="px-2">
                <v-btn
                    class="new-button"
                    color="primary"
                    @click="carregarVB()"
                >
                    <v-icon left>mdi-arrow-down</v-icon> Carregar VB
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3" class="py-4">
                <v-text-field
                    label="Categoria"
                    outlined
                    dense
                    v-model="value.categoria_produto"
                    readonly
                    class="input-cinza"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-data-table
            :headers="listaHeaderProduto"
            :items="produto"
            :search="buscaProduto"
            item-key="id_produto"
            class="elevation-0 tabela"
            :items-per-page="5"
            :footer-props="{
                'items-per-page-options': [5, 10, 15, 25, 50, 100, -1],
            }"
            :options.sync="pagination"
            no-data-text="Importe uma base de produtos para começar."
        >
            <template v-slot:[`item.pdv`]="{ item }">
                <v-checkbox
                    :ripple="false"
                    v-model="item.pdv"
                    hide-details
                    class="d-inline-flex mt-0"
                ></v-checkbox>
            </template>
            <template v-slot:[`item.vb_pdv`]="{ item }">
                <v-text-field
                    :ripple="false"
                    dense
                    outlined
                    v-mask="'####'"
                    class="input-cinza"
                    v-model="item.vb_pdv"
                    @change="vbChange(item)"
                    hide-details
                ></v-text-field>
            </template>
        </v-data-table>

        <v-row no-gutters class="mb-3 mt-1">
            <v-col cols="12" class="px-2 ml-auto" align="end">
                <v-btn
                    class="ml-4 new-button"
                    color="primary"
                    @click="abrirImportacao()"
                >
                    <v-icon left>mdi-upload</v-icon> Importar Base de Produtos
                </v-btn>
                <v-btn
                    class="ml-2 mb-1 new-button"
                    color="error"
                    @click="limpaProdutos(true)"
                >
                    <v-icon left>mdi-trash-can</v-icon> Limpar Produtos
                </v-btn>
                <v-btn
                    class="ml-2 mb-1 new-button"
                    color="primary"
                    @click="carregarProduto()"
                >
                    <v-icon left>mdi-arrow-up</v-icon> Carregar Produtos Salvos
                </v-btn>
                <v-btn
                    class="ml-2 mb-1 new-button"
                    color="primary"
                    @click="salvarProduto()"
                >
                    <v-icon left>mdi-arrow-down</v-icon> Salvar Produtos Selecionados
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table
            :headers="listaHeaderProdutoSalvo"
            :items="produtoSalvo"
            item-key="nome"
            class="elevation-0 tabela mt-4"
            hide-default-footer
            disable-sort
        >
            <template v-slot:[`item.pdv`]="{ item }">
                <v-checkbox
                    :ripple="false"
                    v-model="item.pdv"
                    hide-details
                    class="d-inline-flex mt-0"
                    disabled
                ></v-checkbox>
            </template>
            <template v-slot:[`item.vb_pdv`]="{ item }">
                <v-text-field
                    :ripple="false"
                    dense
                    outlined
                    class="input-cinza"
                    v-mask="'####'"
                    v-model="item.vb_pdv"
                    hide-details
                ></v-text-field>
            </template>
        </v-data-table>

        <v-overlay :value="carregando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-overlay
            :value="semAcesso"
            :absolute="true"
            :opacity="0.1"
            :z-index="3"
        ></v-overlay>

        <importar-produtos
            ref="importarProdutos"
            @importar="importar"
            @exportarModelo="exportarModelo"
        ></importar-produtos>
    </v-form>
</template>

<script>
import importarProdutos from "./importarProdutos.vue";

export default {
    components: { importarProdutos },
    inject: ["listaCampos"],
    props: ["value"],
    async created() {
        var lista = await this.listaCampos;
        this.lista.categoria_produto = lista.categoria_produto || [];
    },
    data() {
        return {
            acordo: {},
            produto: [],
            produtoSalvo: [],
            buscaProduto: "",
            vb: "",
            listaHeaderProduto: [
                { text: "PDV", value: "pdv", align: "center", class: "th-separador", width: "60px" },
                { text: "Código", value: "codigo", align: "center", class: "th-separador" },
                { text: "Marca", value: "marca", align: "center", class: "th-separador" },
                { text: "Descrição", value: "nome", align: "center", class: "th-separador" },
                { text: "Ativo/Inativo", value: "ativo_inativo", align: "center", class: "th-separador" },
                { text: "VB", value: "vb_pdv", align: "center", width: "120px" },
            ],
            listaHeaderProdutoSalvo: [
                { text: "PDV", value: "pdv", align: "center", class: "th-separador", width: "60px" },
                { text: "Produtos Salvos", value: "nome", align: "center", class: "th-separador" },
                { text: "Quantidade de VB", value: "vb_pdv", align: "center" },
            ],
            lista: {
                categoria_produto: [],
            },
            carregando: false,
            pagination: {},
            semAcesso: false,
        };
    },
    computed: {
        produtoSelecionado() {
            return this.produto.filter((item) => item.pdv);
        },
    },
    methods: {
        async vbChange(value) {
            if (value.vb_pdv !== "") {
                value.pdv = true;
            } else {
                value.pdv = false;
            }
            await this.$forceUpdate();
        },
        setProdutos(produtos) {
            this.produto = produtos.map((item) => ({ ...item }));
        },
        carregarVB() {
            if (!this.vb) return;
            for (let item of this.produto) {
                if (item.pdv) {
                    this.$set(item, "vb_pdv", this.vb);
                }
            }
            this.$forceUpdate();
        },
        salvarProduto() {
            this.produtoSalvo = this.produtoSelecionado.map((item) => ({
                ...item,
            }));

            const grupos = [...new Set(this.produtoSalvo.map((item) => item.grupo))].sort().join(" - ");
            this.value.categoria_produto = grupos;
            this.$dialog.notify.success(
                `${this.produtoSalvo.length} produtos salvos com sucesso!`,
                { position: "top-right", timeout: 3000 }
            );
        },
        carregarProduto() {
            if (this.produtoSalvo.length === 0) {
                this.$dialog.notify.warning("Nenhum produto salvo encontrado.", {
                    position: "top-right",
                    timeout: 3000,
                });
                return;
            }
            for (let salvo of this.produtoSalvo) {
                const item = this.produto.find((p) => p.id_produto === salvo.id_produto);
                if (item) {
                    this.$set(item, "pdv", salvo.pdv);
                    this.$set(item, "vb_pdv", salvo.vb_pdv);
                }
            }
            this.$forceUpdate();
            this.$dialog.notify.success("Produtos carregados com sucesso!", {
                position: "top-right",
                timeout: 3000,
            });
        },
        limpaProdutos(notify = false) {
            for (let item of this.produto) {
                item.pdv = false;
                item.vb_pdv = "";
            }
            this.produtoSalvo = [];
            if (notify) {
                this.$forceUpdate();
            }
        },
        abrirImportacao() {
            this.$refs.importarProdutos.abrir();
        },
        importar() {
            var dadosTemp = this.$refs.importarProdutos.dadosTemp;

            this.produto = dadosTemp.map((item) => ({ ...item }));

            this.$forceUpdate();
            this.salvarProduto();
        },
        async exportarModelo() {
            this.$refs.importarProdutos.carregando = true;

            try {
                var response = await this.$http().post(
                    "/acordoGC/modeloProdutos",
                    { data: {} }
                );

                window.location = this.$http("baseURL") + response.data.url;
            } catch (e) {
                this.$dialog.notify.error(
                    "Erro ao exportar modelo de produtos.",
                    { position: "top-right", timeout: 3000 }
                );
            }

            this.$refs.importarProdutos.carregando = false;
        },
        validate() {
            return this.produtoSalvo.length > 0;
        },
        reset() {
            this.produto = [];
            this.produtoSalvo = [];
        },
    },
};
</script>
